import React from 'react'
import { NextSeo } from 'next-seo'
import ProductionEquipmentSelector from '../components/design-system/commerce/ProductionEquipmentSelector'
import PageShell from '../components/design-system/foundations/PageShell'
import { wrapper } from '../store/configStore'
import { productsReceived, productsSetFilters } from '../store/slices/entities/products'
import { SERVER_IP } from '../store/middleware/api'
import { compactCatalogProducts } from '../utilities/catalogPublicPayload'
import { requestPageData } from '../utilities/boundedPageData'

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
  const response = await requestPageData({
    required: true,
    validateData: Array.isArray,
    url: `${SERVER_IP}/inventory/product`,
    label: 'complete rental equipment catalog'
  })
  const products = compactCatalogProducts(response.data)

  store.dispatch({ type: productsReceived.type, payload: products })
  store.dispatch({ type: productsSetFilters.type, payload: {
    bundle: false,
    categories: {},
    mainCat: null,
    single: false,
    static: true
  } })

  return {
    props: {},
    revalidate: 3600
  }
})

const Rentals = () => {
  return <PageShell>
    <NextSeo
      title='Complete Rental Equipment Catalog | Miami Sound Rental'
      description='Browse Miami Sound Rental equipment across sound, staging, visuals, DJ equipment, lighting and special effects in one catalog.'
      noindex
      openGraph={{
        title: 'Complete Rental Equipment Catalog | Miami Sound Rental',
        description: 'Search and compare rental equipment across every category before choosing your event dates.',
        url: 'https://miamisoundrental.com/rentals',
        site_name: 'Miami Sound Rental'
      }}
    />

    <ProductionEquipmentSelector mode='browse' />
  </PageShell>
}

export default Rentals
